export default __webpack_public_path__ + "static/media/JobOne4.b2dedeb5.jpg";